import axios from 'axios';

export const GroupsService = {
  async getGroups(page, perPage = 10) {
    const res = await axios.get('rbac/v1/groups/', {
      params: {
        page,
        size: perPage,
      },
    });

    if (res.status === 200) {
      return res.data;
    }

    return Promise.reject();
  },
  async getAllGroups() {
    const res = await axios.get('rbac/v1/groups/all/');

    if (res.status === 200) {
      return res.data;
    }

    return Promise.reject();
  },
  async getGroupsByRole(id) {
    const res = await axios.get(`rbac/v1/groups/role/${id}/`);

    if (res.status === 200) {
      return res.data;
    }

    return Promise.reject();
  },
  async createGroups(payload) {
    const res = await axios.post('rbac/v1/groups/', payload);

    if (res.status === 201) {
      return true;
    }

    return Promise.reject();
  },
  async deleteGroups(id) {
    const res = await axios.delete(`rbac/v1/groups/${id}/`);

    if (res.status === 200) {
      return true;
    }

    return Promise.reject();
  },
  async updateGroups(data, id) {
    const res = await axios.put(`rbac/v1/groups/${id}/`, data);

    if (res.status === 200) {
      return true;
    }

    return Promise.reject();
  },
};
